import { render, staticRenderFns } from "./LitigationDetail.vue?vue&type=template&id=6fb3e66e&scoped=true"
import script from "./LitigationDetail.vue?vue&type=script&lang=js"
export * from "./LitigationDetail.vue?vue&type=script&lang=js"
import style0 from "./LitigationDetail.vue?vue&type=style&index=0&id=6fb3e66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb3e66e",
  null
  
)

export default component.exports